import styled from 'styled-components';

export const Terms = styled.div`
  ul {
    list-style-position: inside;
  }
`;

export const Logotipo = styled.img`
  max-width: 120px;
  min-width: 80px;
`;

export const Center = styled.div`
  text-align: center;
  margin-bottom: 40px;
`;